import { cn } from '@/lib/utils'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { MessageCircleMore } from 'lucide-react'

type Props = {
  comment?: string | null
  adminComment?: string | null
  iconClassName?: string
  badgeClassName?: string
}

const EventParticipantCommentIndicators = ({
  comment,
  adminComment,
  iconClassName = 'w-4 h-4',
  badgeClassName = 'absolute -right-1 -bottom-1',
}: Props) => {
  const userComment = comment?.trim() || ''
  const adminText = adminComment?.trim() || ''
  const hasUserComment = userComment.length > 0
  const hasAdminComment = adminText.length > 0

  if (!hasUserComment && !hasAdminComment) return null

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn(
            'rounded-full bg-card p-0.5 inline-flex',
            badgeClassName,
          )}
        >
          <MessageCircleMore
            className={cn(iconClassName, 'text-accent-foreground')}
          />
        </span>
      </TooltipTrigger>
      <TooltipContent className='max-w-[300px] wrap-break-word space-y-2'>
        {hasAdminComment ? (
          <div>
            <div className='text-xs font-medium text-info-foreground'>
              Admin comment
            </div>
            <div>{adminText}</div>
          </div>
        ) : null}
        {hasUserComment ? (
          <div>
            <div className='text-xs font-medium text-muted-foreground'>
              User comment
            </div>
            <div>{userComment}</div>
          </div>
        ) : null}
      </TooltipContent>
    </Tooltip>
  )
}

export default EventParticipantCommentIndicators
